"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nameToPath = exports.SpeakersRenderListOfCards = void 0;
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _react = _interopRequireDefault(require("react"));
var _index = require("./index");
var _latinize = _interopRequireDefault(require("latinize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const nameToPath = name => {
  if (!name) {
    throw Error('Name must not be undefined');
  }
  return (0, _latinize.default)(name).replace(/[$&+,:;=?@#|'<>.^*()%!`~]+/g, '').replace(/\s+/g, '-').replace(/^-+|-+(?=-|$)/g, '').toLowerCase();
};
exports.nameToPath = nameToPath;
const thumbnailDirectory = '/assets/images/speakers/thumbnails/';
const SpeakersRenderListOfCards = people => {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "con-list"
  }, people.map(item => {
    return /*#__PURE__*/_react.default.createElement(_index.SpeakerCard, {
      speakerId: item.speakerId,
      key: item.speakerId,
      imageUrl: thumbnailDirectory + item.image,
      name: item.name,
      jobTitle: item.jobTitle,
      description: item.description
    });
  }));
};
exports.SpeakersRenderListOfCards = SpeakersRenderListOfCards;